import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL || '';
const CACHE_KEY = 'gdl_cache';

function readCache() {
  try { return JSON.parse(localStorage.getItem(CACHE_KEY) || '{}'); } catch { return {}; }
}
function writeCache(patch) {
  const c = readCache();
  localStorage.setItem(CACHE_KEY, JSON.stringify({ ...c, ...patch, _ts: Date.now() }));
}

export function useGDLData() {
  const user = JSON.parse(localStorage.getItem('gdl_demo_user') || '{}');
  const csId = user?.id;
  const cache = readCache();

  const [wallet, setWallet] = useState(cache.wallet || null);
  const [ledger, setLedger] = useState(cache.ledger || []);
  const [billsHistory, setBillsHistory] = useState(cache.billsHistory || []);
  const [funds, setFunds] = useState(cache.funds || []);
  const [investments, setInvestments] = useState(cache.investments || []);
  const [stocks, setStocks] = useState(cache.stocks || null);

  const refresh = useCallback(() => {
    if (!csId) return;
    axios.get(`${API}/api/demo/gdl/wallet/${csId}`, { withCredentials: true }).then(r => {
      setWallet(r.data); writeCache({ wallet: r.data });
    }).catch(() => {});
    axios.get(`${API}/api/demo/gdl/ledger/${csId}`, { withCredentials: true }).then(r => {
      setLedger(r.data); writeCache({ ledger: r.data });
    }).catch(() => {});
    axios.get(`${API}/api/demo/gdl/bills-history/${csId}`, { withCredentials: true }).then(r => {
      setBillsHistory(r.data); writeCache({ billsHistory: r.data });
    }).catch(() => {});
    axios.get(`${API}/api/demo/gdl/funds`).then(r => {
      setFunds(r.data); writeCache({ funds: r.data });
    }).catch(() => {});
    axios.get(`${API}/api/demo/gdl/investments/${csId}`, { withCredentials: true }).then(r => {
      setInvestments(r.data); writeCache({ investments: r.data });
    }).catch(() => {});
    axios.get(`${API}/api/demo/gdl/stocks/${csId}`, { withCredentials: true }).then(r => {
      setStocks(r.data); writeCache({ stocks: r.data });
    }).catch(() => {});
  }, [csId]);

  useEffect(() => { refresh(); }, [refresh]);

  return { user, csId, wallet, ledger, billsHistory, funds, investments, stocks, refresh };
}
